import { Grid } from '@material-ui/core';
import { useBaseStore, useUserStore } from '@roc/feature-app-core';
import { Button, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { FundingPreference } from './fundingPreference';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import WithDocumentActions from '../../../utils/withDocumentActions';

export type FundingPreferenceProps = {
  open?: boolean;
  onClose?: () => void;
  loanId: string;
  document: Document;
};

export const FundingPreferenceDialog = observer(
  (props: FundingPreferenceProps) => {
    const { open, onClose, loanId, document } = props;
    const taskId = document?.taskId;
    const { globalStore } = useBaseStore();
    const { isClosingAttorney } = globalStore.userFeatures;

    const {
      documentStore: {
        documentFormStore: { fundingPreferenceStore },
      },
    } = useDocumentStore();
    const { userStore } = useUserStore();

    const onSubmit = () => {
      fundingPreferenceStore.submitFundingEntity();
    };

    useEffect(() => {
      fundingPreferenceStore.setLoanId(loanId);
    }, [fundingPreferenceStore, loanId]);

    const getActions = () => {
      return (
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Button
              onClick={onClose}
              color="primary"
              variant="outlined"
              testId="cancel"
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <WithDocumentActions
              document={document}
              component={Button}
              onClick={onSubmit}
              color="primary"
              variant="contained"
              testId="confirm"
              disabled={!fundingPreferenceStore.canEdit && !globalStore.userFeatures.isClosingReviewer}
            >
              Save
            </WithDocumentActions>
          </Grid>
        </Grid>
      );
    }

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            open={open}
            title="Loan Closing Data"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={<FundingPreference />}
            dialogActions={getActions()}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Loan Closing Data"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={<FundingPreference />}
            dialogActions={getActions()}
          />
        )}
      </>
    );
  }
);

export default FundingPreferenceDialog;
